<div>
  <nav
    class="navbar navbar-expand-lg navbar-light py-3 position-sticky top-0 z-3"
    style="background-color: #141ed2;"
  >
    <div class="container">
      <div>
        <a class="navbar-brand text-black-50" href="/#/account/login">
          <img
            loading="lazy"
            src="assets/images/Logo_LoathanhtoanMB1.png"
            alt="Logo"
            height="40"
          />
        </a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mt-2">
            <a class="nav-link" href="#process-steps">Cách hoạt động</a>
          </li>
          <li class="nav-item mt-2">
            <a class="nav-link" href="#why-choose-section">Ưu điểm</a>
          </li>
          <li class="nav-item mt-2">
            <a class="nav-link" href="#solution-package-section">Giải pháp</a>
          </li>
          <li class="nav-item mt-2">
            <a class="nav-link" href="#package-section">Khách hàng</a>
          </li>
          <li class="nav-item mt-2">
            <a class="nav-link" href="#question">FAQ</a>
          </li>
          <li class="nav-item mt-2">
            <button
              class="btn bg-white text-primary btn-lg rounded-4"
              style="margin-top: -0.3rem;"
            >
              <a href="tel:1900998893" class="font-weight-bolder text-primary">
                1900 99.88.93
              </a>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <section id="hero-section" class="hero-section py-5 bg-content">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h1 class="font-weight-bold">
            Loa thanh toán
          </h1>
          <h3>Ting ting vào ví - Buôn bán như ý</h3>
          <p class="lead mt-4">
            Loa thông báo tiền về giúp người bán hàng xác nhận thanh toán
            <span class="highlight">nhanh chóng, an toàn</span> mà không cần
            kiểm tra điện thoại
          </p>
          <div class="mt-4">
            <button
              class="listen-button"
              class="btn btn-outline-primary btn-lg mr-3"
              [ngClass]="{ 'playing': isPlaying }"
              (click)="playAudio()"
            >
              <img
                loading="lazy"
                loading="lazy"
                [src]="isPlaying ? 'https://cdn.builder.io/api/v1/image/assets/TEMP/73a4d5b7674bd782f322781ffb0a0975f4e938cdd00fb12a49694fe07a1372d4?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb' :  'https://cdn.builder.io/api/v1/image/assets/TEMP/6d87a1901c603907f22af955c5a7df72557bc9246325c9f0166e9cfbb386a10e?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb'"
                alt=""
                class="button-icon"
              />
              <span class="button-text"
                >{{ isPlaying ? 'Đang phát' : 'Nghe thử' }}</span
              >
            </button>
            <button
              class="btn btn-primary btn-lg"
              [attr.disabled]="!selectedPackageId ? true : null"
              (click)="openLink()"
            >
              Đăng ký ngay
            </button>
          </div>
        </div>
        <div class="col-md-6 text-center">
          <img
            loading="lazy"
            src="assets/images/landing.png"
            alt="Loa Thanh Toán"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
    <div class="container mt-4">
      <div class="row align-items-center">
        <div class="col-md-6 text-center">
          <div class="image">
            <img
              src="assets/images/tracking-img.svg"
              loading="lazy"
              alt="Loa Thanh Toán"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-md-6 text-md-right">
          <h3 class="font-weight-bold">
            Kiểm tra trạng thái đơn hàng của bạn
          </h3>
          <p class="lead mt-4">
            Tra cứu đơn hàng chỉ với 1 chạm!
          </p>
          <div class="mt-4">
            <button class="btn btn-primary btn-lg" (click)="openSearch()">
              Tra cứu đơn hàng
              <!-- <p class="p-0 m-0">Tra cứu đơn hàng</p> -->
              <i class="ri-arrow-right-fill ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="process-steps" class="process-steps text-center py-5">
    <h2 class="mb-5">Cách hoạt động của Loa thanh toán</h2>

    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 text-center images-section-2">
          <img
            loading="lazy"
            src="assets/images/loa_wifi.png"
            alt="Loa Thanh Toán"
            class="img-fluid"
          />
        </div>
        <div class="col-md-6">
          <div class="bg-light rounded-5 col-md-12 p-3 mb-3 font-size-18">
            <h3>01.</h3>
            Khách hàng quét QR bằng ứng dụng Mobile Banking của bất kì ngân hàng
            nào
          </div>
          <div class="bg-light rounded-5 col-md-12 p-3 font-size-18 mb-3">
            <h3>02.</h3>
            Khách hàng xác nhận thanh toán
          </div>
          <div class="bg-light rounded-5 col-md-12 p-3 font-size-18">
            <h3>03.</h3>
            Loa thông báo đã nhận được tiền
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="why-choose-section" class="why-choose-section text-center py-5">
    <h2 class="mb-5">Tại sao chọn Loa Thanh Toán</h2>
    <div class="container">
      <div class="row my-2">
        <div class="col-6 col-md-3">
          <div class="bg-light text-left pl-2 p-1 rounded-3">
            <div class="mb-2">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/e3344d125c957e4d301974b23b3ba4ce42b758686227cee4faee35d2022ea143?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt="Information icon"
                class="icon-image"
              />
            </div>
            <h3 class="fw-bold text-primary m-0">
              <span class="font-size-24">0</span> đồng
            </h3>
            <p class="small font-size-15">Phí mua thiết bị</p>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="bg-light text-left pl-2 p-1 rounded-3">
            <div class="mb-2">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/a994e68677042cc1ae8fd5df93379a3df38eb1f749c2947b656131e373f2b15c?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="feature-icon"
              />
            </div>
            <h3 class="fw-bold text-primary m-0">
              <span class="font-size-24">1</span> đổi
              <span class="font-size-24">1</span>
            </h3>
            <p class="small font-size-15">Bảo hành trọn đời</p>
          </div>
        </div>

        <div class="col-6 col-md-3 mt-3 mt-md-0">
          <div class="bg-light text-left pl-2 p-1 rounded-3">
            <div class="mb-1">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/58cb95ee3147b096fc32f4983a6c9097189d357b2ec7d4399265ab955c8d6d6f?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="feature-icon"
              />
            </div>
            <h3 class="fw-bold text-primary m-0">
              <span class="font-size-24">2</span> ngày pin
            </h3>
            <p class="small font-size-15 mb-0">
              Dùng thoải mái, không lo ngắt quãng
            </p>
          </div>
        </div>
        <div class="col-6 col-md-3 mt-3 mt-md-0">
          <div class="bg-light text-left pl-2 p-1 rounded-3">
            <div class="mb-2">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/9bfdaf08a64f7466d42127639c086623929c75230769bd25e889ba4b27f1d992?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="feature-icon"
              />
            </div>
            <h3 class="fw-bold text-primary m-0">
              <span class="font-size-24">3</span> bước
            </h3>
            <p class="small font-size-15">
              Đăng ký và nhận loa
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    id="solution-package-section"
    class="solution-package-section text-center py-5"
  >
    <h2 class="mb-2">Nhận trọn bộ giải pháp Loa Thanh Toán</h2>
    <h3>Chỉ từ 37.222đ/tháng</h3>
    <div class="container">
      <div class="row justify-content-center mt-3">
        <div class="col-md package-item">
          <h4>Bộ sản phẩm Loa Thanh Toán</h4>
          <ul>
            <li>Loa báo kết quả giao dịch</li>
            <li>QR Code thanh toán in sẵn</li>
            <li>Cáp sạc đi kèm</li>
            <li>Sim data 4G đã kích hoạt</li>
          </ul>
          <img
            loading="lazy"
            src="assets/images/loa_wifi.png"
            alt="Logo"
            height="175rem"
          />
        </div>
        <div class="col-md package-item">
          <h4>Ứng dụng quản lý và báo cáo tiền về</h4>
          <ul>
            <li>Theo dõi doanh thu ngay trên app MBBank</li>
            <li>Quản lý QR nhận tiền</li>
            <li>Xem và so sánh doanh thu theo thời gian</li>
            <li>Báo cáo chi tiết về tài chính cửa hàng</li>
          </ul>
          <img
            loading="lazy"
            src="assets/images/img-price-card.png"
            alt="Logo"
            height="175rem"
          />
        </div>
      </div>
    </div>
  </section>
  <div class="solution-package-section text-center py-5">
    <div class="container">
      <section class="container content-wrapper px-3 pt-3 text-center">
        <div class="text-center">
          <h2 class="fw-bold">
            Các gói dịch vụ Loa thanh toán
          </h2>
          <p class="m-0 font-size-15">
            Nhận ngay loa thanh toán miễn phí khi đăng ký gói dịch vụ
          </p>
        </div>
        <div class="row d-md-flex mb-5">
          <ng-container *ngFor="let product of products">
            <article
              class="card-product col-md-6"
              [class.active]="activeProduct?.name === product.name"
              (click)="setActiveProduct(product)"
            >
              <div class="product-content">
                <img
                  loading="lazy"
                  (click)="selectProduct(product)"
                  [src]="product.src"
                  alt="{{ product.name }} product image"
                  class="product-image img-fluid"
                />
                <div class="product-details">
                  <h2 class="product-title">
                    {{ product.name === 'wifi' ? 'Loa Wifi' : 'Loa 4G' }}
                  </h2>
                  <p class="product-description">
                    {{ product.name === 'wifi' ? 'Loa sử dụng kết nối wifi' :
                    'Loa kết nối sim 4G' }}
                  </p>
                  <p class="product-accessories">
                    {{ product.name === 'wifi' ? 'Phụ kiện gồm dây sạc type C và
                    bảng mã QR' : 'Phụ kiện gồm dây sạc type C, bảng mã QR, sim
                    4G đã kích hoạt' }}
                  </p>
                </div>
              </div>
              <div
                class="quantity-stepper"
                *ngIf="activeProduct?.name === product.name"
              >
                <button
                  class="stepper-button"
                  aria-label="Decrease quantity"
                  (click)="changeQuantity(product, -1); $event.stopPropagation()"
                >
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/a6eb9af969ef8b6732e8769fbb384f8b17f21d751bb1d9649a679ff48a7443f6?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                    alt=""
                    class="stepper-icon"
                  />
                </button>
                <span class="quantity-amount" aria-live="polite"
                  >{{ quantities[product.name] }}</span
                >
                <button
                  class="stepper-button"
                  aria-label="Increase quantity"
                  (click)="changeQuantity(product, 1); $event.stopPropagation()"
                >
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/911a195508de5b43dfdef0a1906ef43fe9643542e750eff09f24c302715fd761?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                    alt=""
                    class="stepper-icon"
                  />
                </button>
              </div>
              <div
                class="checkbox-container"
                *ngIf="activeProduct?.name === product.name"
              >
                <input
                  type="checkbox"
                  (change)="onCheckboxChange($event)"
                  class="checkbox"
                  [checked]="activeProduct?.name === product.name"
                />
              </div>
            </article>
          </ng-container>
        </div>
        <section class="offer-container my-3 text-left">
          <h3 class="offer-text">🔥 Ưu đãi siêu hấp dẫn chỉ trong tháng {{currentMonth}} </h3>
        </section>
        <div class="plan-cards-container row d-md-flex">
          <article
            class="plan-card border col-md"
            [class.popular]="item.tag === 'Phổ biến nhất'"
            [class.best-value]="item.tag === 'Tiết kiệm nhất'"
            [class.selected]="selectedPackageId === item.id"
            *ngFor="let item of packages"
            (click)="selectPackage(item.id)"
          >
            <div class="plan-content">
              <h2 class="plan-duration">{{ item.original_duration }} tháng</h2>
              <p class="plan-feature">{{ item.benefit }}</p>
              <p class="plan-bonus" *ngIf="item.bonus_duration" >
                Tặng thêm
                <span class="bonus-months">
                  {{ item.bonus_duration }} tháng
                </span>
              </p>
            </div>
            <div class="plan-pricing">
              <div class="original-price-container">
                <span class="original-price"
                  >{{ item.original_price | number:'1.0-0' }}
                  <ins>đ</ins>
                </span>
                <div class="strike-through"></div>
              </div>
              <span class="discounted-price"
                >{{ item.discounted_price | number:'1.0-0' }}
                <ins>đ</ins>
              </span>
              <span class="price-per-month"
                >({{ item.price_per_month | number:'1.0-0' }}
                <ins>đ</ins>
                /tháng)</span
              >
            </div>
            <span *ngIf="item.tag === 'Phổ biến nhất'" class="popular-tag"
              >Phổ biến nhất</span
            >
            <span *ngIf="item.tag === 'Tiết kiệm nhất'" class="best-value-tag"
              >Tặng thêm 50%, tiết kiệm nhất</span
            >
          </article>
        </div>
        <div class="text-left mb-3">
          <span style="font-size: 0.8rem;"
            ><span style="color: red; font-weight: bold;">*</span>Giá các gói
            dịch vụ đã bao gồm VAT
          </span>
        </div>

        <button
          class="btn-viettel fixed-button"
          [attr.disabled]="!selectedPackageId ? true : null"
          (click)="openLink()"
        >
          Đăng ký ngay
        </button>
      </section>
    </div>
  </div>
  <section
    id="package-section"
    class="solution-package-section text-center py-5"
  >
    <h2 class="mb-2">
      Loa Thanh Toán phù hợp với đa dạng loại hình kinh doanh
    </h2>
    <div class="container">
      <div class="d-md-flex justify-content-around mt-4">
        <div class="item-categories">
          <div class="bg-light width-img p-3 mb-2 rounded-circle">
            <span class="mdi mdi-medical-bag"></span>
          </div>
          <p>Nhà thuốc</p>
        </div>
        <div class="item-categories">
          <div class="bg-light width-img p-3 mb-2 rounded-circle">
            <span class="mdi mdi-face-woman-outline"></span>
          </div>
          <p>Dịch vụ làm đẹp</p>
        </div>
        <div class="item-categories">
          <div class="bg-light width-img p-3 mb-2 rounded-circle">
            <span class="mdi mdi-silverware"></span>
          </div>
          <p>Quán ăn</p>
        </div>
        <div class="item-categories">
          <div class="bg-light width-img p-3 mb-2 rounded-circle">
            <span class="mdi mdi-coffee"></span>
          </div>
          <p>
            Tiệm cà phê
          </p>
        </div>
      </div>
      <div class="d-md-flex justify-content-around mt-4">
        <div class="item-categories">
          <div class="bg-light width-img p-3 mb-2 rounded-circle">
            <span class="mdi mdi-storefront-outline"></span>
          </div>
          <p>Tạp hóa</p>
        </div>
        <div class="item-categories">
          <div class="bg-light width-img p-3 mb-2 rounded-circle">
            <span class="mdi mdi-cart-outline"></span>
          </div>
          <p>Siêu thị</p>
        </div>
        <div class="item-categories">
          <div class="bg-light width-img p-3 mb-2 rounded-circle">
            <span class="mdi mdi-store"></span>
          </div>
          <p>Cửa hàng</p>
        </div>
        <div class="item-categories">
          <div class="bg-light width-img p-3 mb-2 rounded-circle">
            <span class="mdi mdi-food-fork-drink"></span>
          </div>
          <p>
            Thực phẩm
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    id="question"
    class="solution-package-section text-center py-5"
    style="margin-bottom: 11rem;"
  >
    <h2 class="mb-2">
      Hỏi và đáp về Loa Thanh Toán
    </h2>
    <div class="container pb-5">
      <div>
        <mat-accordion class="mt-3 d-md-flex justify-content-center">
          <mat-expansion-panel
            class="p-2 rounded-5 w-100"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                Loa Thanh Toán là gì?
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="text-left">
              Loa Thanh Toán là thiết bị phát âm thanh bằng giọng nói, thông báo
              kết quả thanh toán qua mã QR. Khi giao dịch thành công, loa sẽ tự
              động đọc chính xác số tiền khách hàng đã chuyển khoản, giúp người
              bán nhận tiền nhanh chóng và an toàn.
            </p>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="mt-3 d-md-flex justify-content-center">
          <mat-expansion-panel
            class="p-2 rounded-5 w-100"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                Tôi muốn đăng ký sử dụng sản phẩm này
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="text-left">
              Hãy điền thông tin vào form đăng ký
              <a class="text-primary" (click)="openLink()">Tại đây</a> hoặc liên
              hệ hotline 0869.1988.93 hoặc hỗ trợ qua Email
              <a href="mailto:info@tomotek.vn">info&#64;tomotek.vn</a>
            </p>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="mt-3 d-md-flex justify-content-center">
          <mat-expansion-panel
            class="p-2 rounded-5 w-100"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                Thiết bị này có an toàn không?
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="text-left">
              Có. Thiết bị này do TOMOTEK phát triển cùng Ngân hàng TMCP Quân
              Đội, đáp ứng các yêu cầu bảo mật quốc tế về an toàn bảo mật thanh
              toán. Tất cả các giao dịch đều được đảm bảo an toàn
            </p>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="mt-3 d-md-flex justify-content-center">
          <mat-expansion-panel
            class="p-2 rounded-5 w-100"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                Tôi mất những chi phí gì để sử dụng Loa Thanh Toán?
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="text-left">
              Khách hàng được tặng miễn phí Loa thanh toán khi đăng ký gói dịch
              vụ chỉ từ 37.222 đ/tháng.
            </p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </section>

  <footer
    style="margin-top: 25rem;"
    class="position-absolute bottom-0 left-0 bg-dark text-white w-100 pt-4"
  >
    <div class="container">
      <div class="row d-md-flex justify-content-md-between">
        <div class="col-md-4 order-md-2 text-center">
          <img
            loading="lazy"
            src="assets/images/Logo_LoathanhtoanMB1.png"
            alt="Loa Thanh Toán"
            class="img-fluid w-100"
          />
        </div>
        <div class="col-md-4 order-md-1">
          <p class="company-info">
            CÔNG TY CỔ PHẦN TOMOTEK<br />
            <br />
            MST: 0110084605
          </p> 
          <!-- <img
            loading="lazy"
            src="assets/images/bct-hanggia.png"
            alt="Loa Thanh Toán"
            class="img-fluid w-20"
          /> -->
          <img
            loading="lazy"
            src="assets/images/bocongthuong.png"
            alt="Loa Thanh Toán"
            class="img-fluid"
          />
        </div>
        <div class="col-md-4 order-md-3">
          <div class="contact-options">
            <a href="tel:1900998893" class="contact-option">
              <i class="fas fa-phone mr-2"></i>
              CSKH: 1900 99.88.93
            </a>
            <a href="tel:0869198893" class="contact-option">
              <i class="fas fa-phone mr-2"></i>
               Zalo: 0869.1988.93
            </a>
            <a href="mailto:loathanhtoan247@tomotek.vn" class="contact-option">
              <i class="fas fa-envelope mr-2"></i>
              loathanhtoan247&#64;tomotek.vn
            </a>
            <div class="text-end">
              <a href="https://www.facebook.com/people/Loa-thanh-to%C3%A1n-MB/61568382606156/" class="social-icon ml-2"
                ><i class="fab fa-facebook"></i
              ></a>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom mt-4 text-center">
      <p>&copy; 2024 Tomotek. All rights reserved.</p>
    </div>
  </footer>
</div>

<div
  #chooseDetails
  class="modal fade"
  id="chooseDetails"
  tabindex="-1"
  aria-labelledby="chooseDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-bottom">
    <div class="delivery-modal">
      <header class="delivery-header">
        <h2 class="delivery-title text-capitalize">
          Loa {{ selectedProduct.name === 'wifi' ? 'WIFI' : '4G' }}
        </h2>
        <button
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </header>
      <main class="text-center">
        <div class="image-container">
          <div
            *ngIf="selectedProduct.name === 'wifi'; else template4g"
            id="wifiCarousel"
            class="carousel slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="assets/images/loa_wifi.png"
                  alt="Loa WIFI"
                  class="d-block w-100 product-image-modal"
                />
              </div>
              <div class="carousel-item">
                <img
                  src="assets/images/loa_4g.png"
                  alt="Loa WIFI QR"
                  class="d-block w-100 product-image-modal"
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#wifiCarousel"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#wifiCarousel"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>

          <ng-template #template4g>
            <img
              loading="lazy"
              src="assets/images/loa_4g.png"
              alt="Loa 4G"
              class="product-image-modal"
            />
          </ng-template>
        </div>

        <p>
          {{ selectedProduct.name === 'wifi' ? 'Loa sử dụng kết nối wifi' : 'Loa
          kết nối sim 4G' }}
        </p>
        <p>
          {{selectedProduct.name === 'wifi' ? 'Phụ kiện gồm dây sạc type C và
          bảng mã QR' : 'Phụ kiện gồm dây sạc type C, bảng mã QR, sim 4G đã kích
          hoạt' }}
        </p>
      </main>
    </div>
  </div>
</div>
<div
  #chooseModal
  class="modal fade"
  id="chooseModal"
  tabindex="-1"
  aria-labelledby="chooseModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-submit modal-bottom">
    <section class="delivery-modal">
      <header class="delivery-header">
        <h2 class="delivery-title text-capitalize">
          Đăng ký nhận tư vấn
        </h2>
        <button
          class="close-button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          aria-label="Close modal"
        ></button>
      </header>
      <div class="modal-content" style="border-radius: 1rem;">
        <div class="solution-package-section text-center py-5">
          <div class="container">
            <div
              class="rounded-4 pl-3 d-md-flex"
              style="
                background-image: linear-gradient(to right, #03319d, #008bff);
              "
            >
              <div class="col-md-7 pt-4">
                <div class="col-md-6">
                  <img
                    loading="lazy"
                    src="assets/images/landing.png"
                    alt="Loa Thanh Toán"
                    class="img-modal"
                  />
                </div>
                <h3 class="text-white text-left font-weight-bold">
                  Loa thông báo tiền về giúp người bán hàng xác nhận thanh toán
                  nhanh chóng, an toàn mà không cần kiểm tra điện thoại
                </h3>
              </div>
              <div class="col-md-5 bg-white rounded-right ml-1 p-3">
                <div class="modal-body p-3">
                  <div class="text-left">
                    <form [formGroup]="formData" (ngSubmit)="saveData()">
                      <div class="row">
                        <div class="form-group row col-md-12">
                          <label
                            class="col-md-12 col-form-label required_label"
                          >
                            {{ 'Họ và tên' | translate }}
                          </label>
                          <div class="col-md-12">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Nhập họ tên"
                              formControlName="fullName"
                            />
                            <div
                              *ngIf="formData.get('fullName')?.invalid && formData.get('fullName')?.touched"
                            >
                              <small class="text-danger"
                                >Họ và tên là bắt buộc.</small
                              >
                            </div>
                          </div>
                        </div>

                        <div class="form-group row col-md-12">
                          <label
                            class="col-md-12 col-form-label required_label"
                          >
                            {{ 'Số điện thoại' | translate }}
                          </label>
                          <div class="col-md-12">
                            <input
                              placeholder="Nhập số điện thoại"
                              type="text"
                              class="form-control"
                              formControlName="phone"
                            />
                            <div
                              *ngIf="formData.get('phone')?.invalid && formData.get('phone')?.touched"
                            >
                              <small class="text-danger"
                                >Số điện thoại không hợp lệ.</small
                              >
                            </div>
                          </div>
                        </div>

                        <div class="form-group row col-md-12">
                          <label
                            class="col-md-12 col-form-label required_label"
                          >
                            {{ 'Tỉnh thành' | translate }}
                          </label>
                          <div class="col-md-12">
                            <ng-select
                              formControlName="provines"
                              [items]="listProvince"
                              bindLabel="ProvinceName"
                              bindValue="ProvinceName"
                              placeholder="Chọn tỉnh thành"
                            >
                            </ng-select>
                            <div
                              *ngIf="formData.get('provines')?.invalid && formData.get('provines')?.touched"
                            >
                              <small class="text-danger"
                                >Vui lòng chọn tỉnh thành.</small
                              >
                            </div>
                          </div>
                        </div>

                        <div class="form-group row col-md-12">
                          <label
                            class="col-md-12 col-form-label required_label"
                          >
                            {{ 'Lời nhắn' | translate }}
                          </label>
                          <div class="col-md-12">
                            <textarea
                              placeholder="Nhập lời nhắn"
                              class="form-control"
                              formControlName="note"
                            ></textarea>
                          </div>
                        </div>
                      </div>

                      <div class="text-center">
                        <button
                          type="submit"
                          class="btn-viettel p-3 rounded-4"
                          [disabled]="formData.invalid"
                        >
                          {{ 'Nhận tư vấn' | translate }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<div
  #searchModal
  class="modal fade"
  id="searchModal"
  tabindex="-1"
  aria-labelledby="searchModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-submit modal-bottom"
    style="max-width: 96vw !important; width: 100% !important;"
  >
    <section class="delivery-modal">
      <header class="delivery-header">
        <h2 class="delivery-title">
          Tra cứu trạng thái đơn hàng
        </h2>
        <button
          class="close-button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          aria-label="Close modal"
        ></button>
      </header>
      <p class="text-danger text-left">
        Nhập tên chủ tài khoản và SĐT/STK của cửa hàng để tra cứu trạng thái đơn
        hàng
      </p>
      <div class="modal-content" style="border-radius: 1rem;">
        <div class="solution-package-section text-center py-3">
          <div class="container">
            <form
              [formGroup]="formData"
              class="mb-2"
              (ngSubmit)="searchOrders()"
            >
              <div class="d-md-flex">
                <div class="form-group row col-md text-left">
                  <label class="col-md-12 col-form-label required_label">
                    {{ 'Tên chủ TK' | translate }}
                  </label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Nhập tên chủ TK viết hoa không dấu"
                      formControlName="fullName"
                    />
                    <div
                      *ngIf="formData.get('fullName')?.invalid && formData.get('fullName')?.touched"
                    >
                      <small class="text-danger">Họ và tên là bắt buộc.</small>
                    </div>
                  </div>
                </div>

                <div class="form-group row col-md text-left">
                  <label class="col-md-12 col-form-label required_label">
                    {{ 'Số điện thoại/Số tài khoản' | translate }}
                  </label>
                  <div class="col-md-12">
                    <input
                      placeholder="Nhập số điện thoại hoặc số tài khoản"
                      type="text"
                      class="form-control"
                      formControlName="note"
                    />
                    <div
                      *ngIf="formData.get('note')?.invalid && formData.get('note')?.touched"
                    >
                      <small class="text-danger"
                        >Cần nhập đầy đủ thông tin</small
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <button
                  type="submit"
                  class="btn-viettel btn btn-primary btn-lg"
                  [disabled]="formData.invalid"
                >
                  {{ 'Tìm kiếm' | translate }}
                </button>
              </div>
            </form>

            <div
              class="table-responsive mt-2"
              *ngIf="listDataSearch.length > 0 "
            >
              <table
                id="basic-datatable"
                class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
              >
                <thead>
                  <tr class="text-center bg-table">
                    <th>{{'#' | translate}}</th>
                    <th>{{'Mã đơn' | translate}}</th>
                    <th>{{'Tên khách hàng' | translate}}</th>
                    <th>{{'SĐT' | translate}}</th>
                    <th>{{'Số TK' | translate}}</th>
                    <th>{{'Trạng thái' | translate}}</th>
                    <th>{{'Loại loa' | translate}}</th>
                    <th>{{'Loại đơn' | translate}}</th>
                    <th>{{'Địa chỉ' | translate}}</th>
                    <th>{{'Ngày tạo đơn' | translate}}</th>
                    <th>{{'Ngày cập nhật' | translate}}</th>
                    <th>{{'Chi tiết trạng thái' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="text-center"
                    *ngFor="let data2 of listDataSearch;let i = index"
                  >
                    <td>{{pageSize*(pageIndex-1) +i+1}}</td>
                    <td class="hyperlink">
                      
                      <a
                          *ngIf="data2.order_code && data2.shipping_unit == 'GHN'"
                          (click)="viewDetails(data2)"
                          class="font-size-14"
                          ngbTooltip="{{'Xem chi tiết đơn' | translate}}"
                          placement="left"
                        >
                         {{data2.order_code}}
                        </a>
                        <a
                          *ngIf="data2.order_code && data2.shipping_unit == 'Viettel post'"
                          (click)="viewDetailsViettel()"
                          class="font-size-14"
                          ngbTooltip="{{'Xem chi tiết đơn' | translate}}"
                          placement="left"
                        >
                         {{data2.order_code}}
                        </a>
                    </td>

                    <td>{{data2.terminal_bank_acc_name }}</td>
                    <td>{{data2.phone }}</td>
                    <td>{{data2.terminal_bank_acc }}</td>
                    <td>
                      {{ data2.status }}
                    </td>
                    <td>
                      {{ data2.device_name }}
                    </td>
                    <td>
                      {{ data2.delevery_mothed == "shipper" ? "Đơn online" :
                      "Đơn trực tiếp" }}
                    </td>
                    <td>{{data2.to_province_name}}</td>
                    <td>{{data2.created_at | date:'dd/MM/yyyy HH:mm'}}</td>
                    <td>{{data2.updated_at | date:'dd/MM/yyyy HH:mm'}}</td>
                    <td>
                      <div class="">
                        <a
                          *ngIf="data2.order_code && data2.shipping_unit == 'GHN'"
                          (click)="viewDetails(data2)"
                          class="font-size-14 text-danger"
                          ngbTooltip="{{'Xem chi tiết đơn' | translate}}"
                          placement="left"
                        >
                          <i class="mdi mdi-eye" style="font-size: large;"></i>
                        </a>
                        <a
                          *ngIf="data2.order_code && data2.shipping_unit == 'Viettel post'"
                          (click)="viewDetailsViettel()"
                          class="font-size-14 text-danger"
                          ngbTooltip="{{'Xem chi tiết đơn' | translate}}"
                          placement="left"
                        >
                          <i class="mdi mdi-eye" style="font-size: large;"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p class="text-danger text-left" *ngIf="flagHide">
            Không tìm thấy kết quả phù hợp
          </p>
        </div>
      </div>
    </section>
  </div>
</div>
